/* eslint-disable jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */
import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { CallToAction } from '@scentregroup/ui'
import classNames from 'classnames'
import ExternalLink from '../external-link'
import { parsePathname, parseHostname } from '../../helpers/url'
import { GetHrefContext } from '../../context'
import style from './index.module.scss'

// This handles the url check for external link or internal link by matching the hostname
const CallToActionWrapper: React.FC<CallToActionWrapperProps> = ({
  url,
  category,
  className,
}): JSX.Element => {
  const getHref = useContext(GetHrefContext)
  const hostname = parseHostname(getHref())
  if (parseHostname(url) === hostname) {
    return (
      <CallToAction
        element={Link}
        to={parsePathname(url)}
        className={classNames(className, style.callToAction)}
      >
        {category}
      </CallToAction>
    )
  }
  return (
    <CallToAction
      element={ExternalLink}
      url={url}
      className={classNames(className, style.callToAction)}
    >
      {category}
    </CallToAction>
  )
}

interface CallToActionWrapperProps {
  url: string
  category: string
  className: string
}

CallToActionWrapper.propTypes = {
  url: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
}

export default CallToActionWrapper
